/**
 * Estado del vínculo con la cuenta nueva de PowerGym (Auth Service), tal como lo manda
 * `GET /api/me` en `as_link`: { status: 'linked'|'unlinked', masked_email, required, required_from, enabled }.
 */
export const asLinkLoaded = (asLink) => ({
    type: 'AS_LINK_LOADED',
    asLink: asLink || null,
});

/** La app de este club no manda `as_link` (core legacy sin el puente): no se bloquea nada. */
export const asLinkUnavailable = () => ({
    type: 'AS_LINK_UNAVAILABLE',
});

/** Al cerrar sesión o cambiar de usuario hay que volver a consultar. */
export const asLinkReset = () => ({
    type: 'AS_LINK_RESET',
});
